import { Input } from "antd";

export const FilterData = (props) => {

    return (

        <Input.Search placeholder="Search Users" onChange={e => {
            let currValue = e.target.value;
           
            let filteredData = props.data.filter(entry =>{
                    eval(props.column)
            });
            // console.log(currValue);
            props.setDataSource(filteredData);
        }} className="p-2" />
    )
}
